import Reveal from "./Reveal";

export default function SectionHeading({ eyebrow, title, sub, align = "left", className = "" }) {
  const alignCls = align === "center" ? "text-center mx-auto items-center" : "text-left items-start";
  return (
    <div className={`flex flex-col ${alignCls} max-w-3xl ${className}`}>
      {eyebrow && (
        <Reveal>
          <span className="ad-eyebrow">{eyebrow}</span>
        </Reveal>
      )}
      <Reveal index={1}>
        <h2 className="mt-4 text-3xl font-extrabold tracking-tight text-[#111827] sm:text-4xl lg:text-[2.9rem] lg:leading-[1.08]">
          {title}
        </h2>
      </Reveal>
      {sub && (
        <Reveal index={2}>
          <p className={`mt-5 text-base leading-relaxed text-[#4B5563] sm:text-lg ${align === "center" ? "mx-auto" : ""}`}>
            {sub}
          </p>
        </Reveal>
      )}
    </div>
  );
}
